/**
 * WARNING: This file was auto-generated by @pp/translator.
 * DO NOT EDIT DIRECTLY!
 * For usage in game package, incorporate `languages` into the GameRoot config.
 */
export const languages = [
  "en",
  "ar",
  "bg",
  "bn",
  "cn",
  "da",
  "de",
  "el",
  "es",
  "fa",
  "fi",
  "fr",
  "hi",
  "hu",
  "hy",
  "id",
  "it",
  "ja",
  "ka",
  "ko",
  "lt",
  "lv",
  "nf",
  "nl",
  "no",
  "pt",
  "ro",
  "ru",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh"
];